/* unplugin-vue-components disabled */import { render } from "./w-tiny-mce.vue?vue&type=template&id=50c67b21&scoped=true&ts=true"
import script from "./w-tiny-mce.vue?vue&type=script&lang=ts"
export * from "./w-tiny-mce.vue?vue&type=script&lang=ts"

import "./w-tiny-mce.vue?vue&type=style&index=0&id=50c67b21&lang=scss&scoped=true"
import "./w-tiny-mce.vue?vue&type=style&index=1&id=50c67b21&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c67b21"]])

export default __exports__